import type { LanguageVoice } from "../types"
import {
  SvgFlagUs,
  SvgFlagEs,
  SvgFlagFr,
  SvgFlagIt,
  SvgFlagPt,
} from "@/shared/ui/svg"
import { GetMyOptionsDtoResVoiceLang } from "@/shared/api/generated"

export const LANGUAGE_VOICES: LanguageVoice[] = [
  {
    label: "English",
    id: GetMyOptionsDtoResVoiceLang.ENGLISH,
    flag: SvgFlagUs,
  },
  {
    label: "Spanish",
    id: GetMyOptionsDtoResVoiceLang.SPANISH,
    flag: SvgFlagEs,
  },
  {
    label: "French",
    id: GetMyOptionsDtoResVoiceLang.FRENCH,
    flag: SvgFlagFr,
  },
  {
    label: "Italian",
    id: GetMyOptionsDtoResVoiceLang.ITALIAN,
    flag: SvgFlagIt,
  },
  {
    label: "Portuguese",
    id: GetMyOptionsDtoResVoiceLang.PORTUGUESE,
    flag: SvgFlagPt,
  },
]
